var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoGenom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5181 18.4203C49.9254 13.7499 59.5879 11.0653 69.8719 11V32.1744C68.9712 32.3319 68.1821 32.8141 67.6298 33.4959L41.5181 18.4203Z",
    fill: "#86D5D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.852 19.4946C109.293 24.5924 116.36 31.7361 121.366 40.2388L103.279 50.6818C102.676 49.9858 101.819 49.5163 100.852 49.4179L100.852 19.4946Z",
    fill: "#A2DADB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9829 37.1628L97.5762 50.7844C98.1288 50.098 98.9208 49.6124 99.8253 49.4542L99.8253 19.271L73.8777 34.2519C74.1031 34.7309 74.2292 35.266 74.2292 35.8306C74.2292 36.3001 74.142 36.7493 73.9829 37.1628Z",
    fill: "#86D5D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8989 11.0021C81.1404 11.1104 90.759 13.8166 99.127 18.4928L73.3185 33.3933C72.7162 32.702 71.862 32.2359 70.8989 32.1379V11.0021Z",
    fill: "#86D5D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1036 34.373L40.9465 19.2712L40.9465 49.418C41.9136 49.5164 42.7708 49.986 43.3736 50.682L67.0069 37.0373C66.8769 36.659 66.8064 36.2532 66.8064 35.8308C66.8064 35.3133 66.9123 34.8206 67.1036 34.373Z",
    fill: "#57C4CB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9236 19.3411C31.4054 24.4266 24.2705 31.5888 19.2178 40.1287L37.6745 50.7847C38.2271 50.0983 39.019 49.6127 39.9236 49.4545L39.9236 19.3411Z",
    fill: "#57C4CB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7019 41.0144C13.9327 49.4028 11.1518 59.0691 11 69.3721L37.0575 54.3279C36.9252 53.9466 36.8533 53.5371 36.8533 53.1107C36.8533 52.5972 36.9576 52.108 37.1462 51.6632L18.7019 41.0144Z",
    fill: "#57C4CB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9209 84.0145V56.7672C38.9323 56.5943 38.0783 56.0303 37.5241 55.2406L11.5049 70.2628L37.6578 85.3622C38.211 84.6665 39.0087 84.174 39.9209 84.0145Z",
    fill: "#57C4CB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11 71.1533C11.1518 81.4564 13.9327 91.1226 18.7019 99.5111L37.0649 88.9091C36.9279 88.5218 36.8533 88.105 36.8533 87.6707C36.8533 87.1651 36.9544 86.6831 37.1375 86.2438L11 71.1533Z",
    fill: "#3299A0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2178 100.397C24.2705 108.937 31.4054 116.099 39.9236 121.184L39.9236 91.3269C38.9426 91.1553 38.0941 90.5987 37.5397 89.8185L19.2178 100.397Z",
    fill: "#3299A0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8719 129.526C59.5879 129.46 49.9254 126.776 41.5181 122.105L67.4944 107.108C68.049 107.883 68.8948 108.436 69.8719 108.607V129.526Z",
    fill: "#3299A0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0863 103.534L43.5154 89.9254C42.9094 90.7168 41.9922 91.2571 40.9465 91.3635L40.9465 121.254L67.0218 106.2C66.8823 105.809 66.8064 105.389 66.8064 104.951C66.8064 104.449 66.9059 103.971 67.0863 103.534Z",
    fill: "#3299A0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M99.127 122.033C90.759 126.709 81.1404 129.415 70.8989 129.523V108.643C71.9406 108.537 72.855 108.001 73.461 107.214L99.127 122.033Z",
    fill: "#037C84"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M97.443 89.8187L73.8979 103.412C74.1117 103.881 74.2307 104.402 74.2307 104.951C74.2307 105.436 74.1376 105.9 73.9681 106.325L99.8269 121.254V91.3271C98.8459 91.1556 97.9974 90.5989 97.443 89.8187Z",
    fill: "#037C84"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M121.366 100.287C116.36 108.789 109.293 115.933 100.852 121.031V91.3635C101.897 91.2571 102.814 90.7168 103.42 89.9254L121.366 100.287Z",
    fill: "#037C84"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M129.514 71.3024C129.339 81.504 126.586 91.0775 121.878 99.3995L103.925 89.0342C104.091 88.6121 104.183 88.152 104.183 87.6706C104.183 87.1179 104.062 86.5934 103.846 86.1221L129.514 71.3024Z",
    fill: "#037C84"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M100.852 70.2628V83.978C101.826 84.0772 102.69 84.5537 103.293 85.2591L129.268 70.2628L100.852 70.2628Z",
    fill: "#037C84"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4097 70.2629L97.5626 85.3623C98.1158 84.6667 98.9135 84.1741 99.8257 84.0146V70.2629L71.4097 70.2629Z",
    fill: "#037C84"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2539 69.4016V73.6204H100.883L103.832 71.511L100.883 69.4016H90.2539Z",
    fill: "#FFDA43"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M100.883 69.4016H111.746V73.6204H100.883V69.4016Z",
    fill: "#FFB654"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M107.419 80.3318C109.87 78.5384 111.889 76.1971 113.257 73.5612C114.632 70.9133 115.359 67.9528 115.359 65H111.14C111.14 69.6911 108.875 74.0384 104.928 76.9271L99.1643 80.9019L104.572 82.4146L107.419 80.3318Z",
    fill: "#80AAFF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4519 111.547H100.883L103.832 109.438L100.883 107.328H90.4519V111.547Z",
    fill: "#FFDA43"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2539 132.611H100.883L104.383 130.501L100.883 128.392H90.2539V132.611Z",
    fill: "#FFDA43"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M88.751 98.8906V103.109H100.883L103.832 101L100.883 98.8906H88.751Z",
    fill: "#FFDA43"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M100.883 98.8906H113.249V103.109H100.883V98.8906Z",
    fill: "#FFB654"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4526 90.4531V94.6719H100.883L103.832 92.5625L100.883 90.4531H90.4526Z",
    fill: "#FFDA43"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M100.883 90.4531H111.746V94.6719H100.883V90.4531Z",
    fill: "#FFB654"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M100.883 107.328H111.746V111.547H100.883V107.328Z",
    fill: "#FFB654"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M100.883 128.392H111.746V132.611H100.883V128.392Z",
    fill: "#FFB654"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5813 121.668C92.1302 123.462 90.1114 125.803 88.743 128.439C87.3682 131.087 86.6416 134.047 86.6416 137H90.8604C90.8604 132.309 93.1247 127.962 97.0725 125.073L100.883 122.113V117.057L94.5813 121.668Z",
    fill: "#FF8859"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0725 114.098C93.1246 111.209 90.8604 106.862 90.8604 102.171V99.8296C90.8604 95.1385 93.1247 90.7912 97.0725 87.9025L100.883 84.9428V83.2665L97.428 82.4149L94.5813 84.4979C92.1302 86.2912 90.1114 88.6325 88.743 91.2684C87.3682 93.9164 86.6416 96.8768 86.6416 99.8296V102.171C86.6416 105.124 87.3682 108.084 88.743 110.732C90.1114 113.368 92.1302 115.709 94.5813 117.503L100.883 122.113L102.955 121.581L100.883 116.886L97.0725 114.098Z",
    fill: "#B3D9FF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0725 76.9271C93.1246 74.0384 90.8604 69.6911 90.8604 65H86.6416C86.6416 67.9528 87.3682 70.9133 88.743 73.5612C90.1114 76.1971 92.1302 78.5384 94.5813 80.3318L100.883 84.9425L101.94 83.4714L100.883 79.7151L97.0725 76.9271Z",
    fill: "#FF8859"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M113.257 91.268C111.889 88.6321 109.87 86.2909 107.419 84.4975L100.883 79.7151V84.9425L104.928 87.9023C108.876 90.791 111.14 95.1383 111.14 99.8294V102.171C111.14 106.862 108.876 111.209 104.928 114.098L100.883 117.057L103.631 120.274L107.419 117.502C109.87 115.709 111.889 113.368 113.257 110.732C114.632 108.084 115.359 105.123 115.359 102.171V99.8294C115.359 96.8765 114.632 93.916 113.257 91.268Z",
    fill: "#FF415B"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M113.257 128.439C111.889 125.803 109.87 123.462 107.419 121.668L100.883 116.886V122.113L104.928 125.073C108.876 127.962 111.14 132.309 111.14 137H115.359C115.359 134.047 114.632 131.087 113.257 128.439Z",
    fill: "#80AAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGenom);
export default __webpack_public_path__ + "static/media/Logo_genom.d4cfc42f705c377512d3e9df54dd6057.svg";
export { ForwardRef as ReactComponent };